export default function TypicalMistakes() {
  const mistakes = [
    { text: 'Читают скрипт', desc: 'Механическое чтение заученного текста убивает живой диалог и вызывает раздражение клиента.' },
    { text: 'Сразу предлагают продукт', desc: 'Презентация до выявления потребности — верный путь получить отказ на первой минуте.' },
    { text: 'Боятся пауз', desc: 'Торопятся заполнить тишину словами, не давая клиенту подумать и ответить.' },
    { text: 'Оправдываются', desc: 'При первом возражении переходят в защиту вместо того, чтобы продолжить диалог.' },
    { text: 'Спорят', desc: 'Пытаются доказать свою правоту, теряя клиента и возможность для дальнейшего общения.' },
    { text: 'Не задают вопросов', desc: 'Говорят монологом, не вовлекая клиента и не выясняя его реальную ситуацию.' },
    { text: 'Не знают цели звонка', desc: 'Начинают разговор без чёткого понимания, чего хотят достичь в этом контакте.' },
    { text: 'Заканчивают без следующего шага', desc: 'Разговор обрывается на «я подумаю» или «пришлите информацию» вместо конкретной договорённости.' },
  ];

  return (
    <section id="mistakes" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Типичные ошибки менеджеров при холодных звонках
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Большинство менеджеров совершают одни и те же ошибки, которые легко исправить при правильном подходе к обучению.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto mb-12">
          {mistakes.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 border border-gray-100 hover:border-teal-200 hover:bg-teal-50 transition-all duration-300 text-center">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-close-line text-xl text-red-500"></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{item.text}</h3>
              <p className="text-xs text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-teal-600 rounded-2xl p-8 md:p-10 text-white">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white/15 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl md:text-2xl font-bold mb-3">Вывод</h3>
                <p className="text-white/90 leading-relaxed text-base">
                  Все эти ошибки — не приговор, а результат отсутствия системного обучения. Когда менеджер понимает цель холодного звонка, владеет техникой открытия разговора и умеет задавать вопросы — страх уходит, а конверсия растёт. Наша программа меняет не просто скрипты, а само отношение сотрудников к холодным звонкам — от «страшно и не работает» до «инструмент, который приносит встречи».
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}